import React, { useMemo } from "react";
import { Button, Modal } from "react-bootstrap";
import { defineMessages, FormattedMessage } from "react-intl";
import { DailyDiscounts, DailyValues } from "../../modification/model";
import { messages } from "../messages";
import { ModalStyledTable, StyledModal } from "./CombinedBookingModal";

export const modalMessages = defineMessages({
  discountsTitle: {
    id: "reservationDetail.appliedDiscounts.title",
    defaultMessage: "Combined rate",
  },
});

interface PromosModalProps {
  isOpen: boolean;
  dailyDiscounts: DailyDiscounts;
  onClose: () => void;
  dailyValues: DailyValues;
}

interface DiscountRow {
  date: string;
  dailyAmount: string;
  discounts: string;
}

export function DiscountModal({ isOpen, onClose, dailyDiscounts, dailyValues }: PromosModalProps) {
  const rows: DiscountRow[] = useMemo(() => {
    const dates = Object.keys(dailyValues);
    dates.sort();
    return dates.map(date => {
      const dailyData = dailyValues[date].amount;
      const currency = dailyValues[date].currency;
      const discountData = dailyDiscounts[date] | 0;
      return {
        date: date,
        dailyAmount: `${dailyData} ${currency}`,
        discounts: `${discountData} ${currency}`,
      };
    });
  }, [dailyDiscounts]);
  return (
    <StyledModal centered show={isOpen} onHide={onClose} backdrop="static">
      <Modal.Header className="bg-[#FF6136] text-white text-xl" closeButton>
        <FormattedMessage {...modalMessages.discountsTitle} />
      </Modal.Header>
      <Modal.Body className="p-4">
        <ModalStyledTable>
          <thead>
            <tr>
              <th>
                <FormattedMessage {...messages.date} />
              </th>
              <th>
                <FormattedMessage {...messages.appliedRate} />
              </th>
              <th>
                <FormattedMessage {...messages.appliedOffers} />
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>{row.date}</td>
                <td>{row.dailyAmount}</td>
                <td>{row.discounts}</td>
              </tr>
            ))}
          </tbody>
        </ModalStyledTable>
        <div className="flex justify-center mt-4">
          <Button className="ml-0" onClick={onClose}>
            <div className="font-weight-bold">
              <FormattedMessage {...messages.close} />
            </div>
          </Button>
        </div>
      </Modal.Body>
    </StyledModal>
  );
}
